var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouceements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1317,
    height: 915,
    viewBox: "0 0 1317 915",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_31_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1040 512C1040 613.068 961.069 695 863.704 695C766.338 695 700.5 613.068 700.5 512C700.5 410.932 766.338 329 863.704 329C961.069 329 1040 410.932 1040 512Z",
    fill: "#F05CDC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_31_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1016 489C1016 569.634 902.96 635 763.519 635C624.077 635 615 569.634 615 489C615 408.366 624.077 343 763.519 343C902.96 343 1016 408.366 1016 489Z",
    fill: "#6C0B87"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_31_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M809 423C809 503.634 743.319 569 662.296 569C581.274 569 576 503.634 576 423C576 342.366 581.274 277 662.296 277C743.319 277 809 342.366 809 423Z",
    fill: "#FC88CE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_31_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604 541C604 621.634 511.82 687 398.111 687C284.402 687 277 621.634 277 541C277 460.366 284.402 395 398.111 395C511.82 395 604 460.366 604 541Z",
    fill: "#B14BDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_31_80",
    x: 424.1,
    y: 52.6,
    width: 892.3,
    height: 918.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_80"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_31_80",
    x: 338.6,
    y: 66.6,
    width: 953.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_80"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_31_80",
    x: 299.6,
    y: 0.600006,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_80"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_31_80",
    x: 0.600006,
    y: 118.6,
    width: 879.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouceements);
export default __webpack_public_path__ + "static/media/annouceements.b13ec991c9f3e39a170875e8d1d4e179.svg";
export { ForwardRef as ReactComponent };